<template>
  <v-row>
    <template v-for="file of files">
      <v-col class="text-center align-content-center fill-height align-content-center" md="1" cols="1" :key="file.id + '_icon'">
        <v-icon style="font-size: 46px; color: rgba(0, 0, 0, 0.32); position: relative; top: 10px;">info</v-icon>
      </v-col>
      <v-col md="3" cols="11" :key="file.id + '_rest'">
        <v-text-field :label="$t('global.itemName')" :value="file.itemName" class="no-line-after-input" readonly outlined>
          <div slot="append" style="position: relative; top: -7px;">
            <v-tooltip top>
              <template #activator="{on}">
                <v-btn icon v-on="on" @click="$emit('download', file.id)">
                  <v-icon>cloud_download</v-icon>
                </v-btn>
              </template>
              {{ $t("global.downloadFile") }}
            </v-tooltip>
          </div>
        </v-text-field>
      </v-col>
    </template>
    <template v-if="files.length > 1">
      <v-col class="text-center align-content-center fill-height align-content-center" md="1" cols="1" @click="downloadAll">
        <v-icon style="font-size: 46px; color: rgba(0, 0, 0, 0.32); position: relative; top: 10px;">archive</v-icon>
      </v-col>
      <v-col md="3" cols="11" @click="downloadAll">
        <v-text-field :label="$t('global.downloadAll')" class="no-line-after-input" readonly outlined>
          <div slot="append" style="position: relative; top: -7px;">
            <v-tooltip top>
              <template #activator="{on}">
                <v-btn icon v-on="on">
                  <v-icon>cloud_download</v-icon>
                </v-btn>
              </template>
              {{ $t("global.downloadFile") }}
            </v-tooltip>
          </div>
        </v-text-field>
      </v-col>
    </template>
  </v-row>
</template>

<script>
export default {
  name: "MultipleFileDownload",
  props: {
    files: {
      required: true,
      type: Array
    }
  },
  methods: {
    downloadAll() {
      for (let file of this.files) {
        this.$emit("download", file.id);
      }
    }
  }
};
</script>

<style scoped></style>
